import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { Modal, Notice } from "../../lib/ui";

/* SMS broadcast to every client with a phone number – port of clientSms.php (API: /api/sms/broadcasts). Admin only; 160 characters per SMS. */

export default function ClientSms() {
  const api = useApi();
  const [msg, setMsg] = useState("");
  const [d, setD] = useState(null);
  const [notice, setNotice] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [results, setResults] = useState(null);
  const load = useCallback(() => api.get("/api/sms/broadcasts").then(setD).catch((e) => setNotice({ tone: "err", text: e.message })), [api]);
  useEffect(() => { load(); }, [load]);
  const send = async () => {
    setConfirm(false); setBusy(true); setResults(null);
    try { const r = await api.post("/api/sms/broadcasts", { message: msg }); setNotice({ tone: r.failed ? "warn" : "ok", text: r.message }); setResults(r.results); setMsg(""); load(); }
    catch (e) { setNotice({ tone: "err", text: e.message }); }
    finally { setBusy(false); }
  };
  const parts = Math.max(1, Math.ceil(msg.length / 160));
  return (
    <main className="pg">
      <PageHeader slug="clientSms" />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <div className="grid2">
        <section className="panel card-pad">
          <h3>New broadcast</h3>
          <div className="field"><label htmlFor="sms-m">Message</label><textarea id="sms-m" rows={6} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Habari! …" /></div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: ".7rem" }}>
            <span style={{ fontSize: ".8rem", color: msg.length > 160 ? "var(--warn)" : "var(--muted)" }}>{msg.length} characters · {parts} SMS each · {d?.recipients ?? "…"} recipients</span>
            <button type="button" className="btn primary" disabled={!msg.trim() || busy} onClick={() => setConfirm(true)}><i className="fas fa-paper-plane" /> {busy ? "Sending…" : "Send to all clients"}</button>
          </div>
          {results && <div className="tbl-wrap" style={{ maxHeight: "18rem", overflowY: "auto", marginTop: "1rem" }}><table className="tbl">
            <thead><tr><th>Client</th><th>Phone</th><th>Result</th></tr></thead>
            <tbody>{results.map((r, i) => <tr key={i}><td>{r.name}</td><td className="mono">{r.phone}</td><td>{r.ok ? <span className="pill-tag ok">Sent</span> : <span className="pill-tag err" title={r.error}>Failed</span>}</td></tr>)}</tbody></table></div>}
        </section>
        <section className="panel card-pad">
          <h3>Recent broadcasts</h3>
          {(d?.history || []).length === 0 ? <p style={{ color: "var(--muted)", margin: 0 }}>No broadcasts yet.</p> : (
            <table className="tbl"><thead><tr><th>Sent</th><th>Message</th><th className="num">OK / failed</th><th /></tr></thead>
              <tbody>{d.history.map((h) => <tr key={h.id}><td style={{ whiteSpace: "nowrap" }}>{String(h.sent_at).slice(0, 16)}</td>
                <td style={{ maxWidth: "16rem", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={h.message}>{h.message}</td>
                <td className="num mono">{h.total_sent} / {h.total_failed}</td>
                <td><button type="button" className="btn sm" onClick={() => setMsg(h.message)}>Reuse</button></td></tr>)}</tbody></table>)}
        </section>
      </div>
      {confirm && (
        <Modal title="Send to every client?" onClose={() => setConfirm(false)}
          actions={<><button type="button" className="btn" onClick={() => setConfirm(false)}>Cancel</button><button type="button" className="btn primary" onClick={send}>Send now</button></>}>
          This sends {parts} SMS to each of {d?.recipients} clients ({parts * (d?.recipients || 0)} messages in total). It can't be undone.
        </Modal>
      )}
    </main>
  );
}
